const airlineCodes = {
    aeromexico: 'AM',
    latam: 'LA',
    virginAustralia: 'VA',
};

export default airlineCodes;
